import {combineReducers} from "redux";
import auth from './auth';
import message from "./message";
import utils from "./utils";

export default combineReducers({
    auth, message, utils
})